"use strict";

import * as THREE from "three";

const CarolineTestoutPetal: ShootPreset =
{
    id: "CarolineTestoutPetal",
    shootCount: 25,

    materialPreset: {
        shootTextureIndex: 5,
        uniforms: {
            shootTextureColorA: { value: new THREE.Color(0.5, 0.09, 0.19) },
            shootTextureColorB: { value: new THREE.Color(0.97, 0.58, 0.85) },
        },
    },

    maxWidth: .75,
    maxHeight: .45,

    widthSegments: 4,
    lengthSegments: 10,

    pathFunction: () => {

        let points = [
            new THREE.Vector3(0, 0, 0),
            new THREE.Vector3(.95, .25, 0),
            new THREE.Vector3(1.85, .9, 0),
        ];

        let path = new THREE.CatmullRomCurve3(
            points, false, "catmullrom", .5
        );

        return path;
    },

    getBinormalOffset: (lengthProgress, widthProgress) => {
        let height = Math.sin((widthProgress / 2) * (Math.PI)) * widthProgress;
        height *= Math.sin((1 - lengthProgress) * Math.PI);

        return height;
    },

    getNormalOffset: (lengthProgress, widthProgress) => {
        if (lengthProgress < .5) {
            return Math.sin((1 - lengthProgress) * Math.PI) * widthProgress;
        } else {
            return (1 - Math.pow(lengthProgress, 32)) * widthProgress;
        }
    },

    transformInstance(i) {
        let progress = (i / this.shootCount);

        const position = new THREE.Vector3(0, 0, 0);
        const rotation = new THREE.Euler(0, 0, 0);
        const quaternion = new THREE.Quaternion();
        const scale = new THREE.Vector3(1, 1, 1);
        const matrix = new THREE.Matrix4();

        position.y = (1 - progress) * 1.25;

        rotation.y = progress * Math.PI * 11;
        rotation.z = .125 * (1 - progress) * Math.PI;
        quaternion.setFromEuler(rotation);

        let uniformScale = .25 + (progress * .75);
        scale.set(uniformScale, uniformScale, uniformScale);

        matrix.compose(
            position,
            quaternion,
            scale);

        return matrix;
    },
}

export const CarolineTestout: BloomPreset = {
    bounds: 1.8,
    shootPresets: [CarolineTestoutPetal],
}

